export default "__VITE_ASSET__Dd9qzTS1__"